import React, { useState } from 'react';
import RewardForm from './RewardForm';
import Success from './Success';

const RewardsAvailable: React.FC = () => {
  const [showSuccessPage, setShowSuccessPage] = useState(false);
  return (
    <div>
      {!showSuccessPage && <RewardForm setSuccess={setShowSuccessPage} />}
      {showSuccessPage && <Success />}
    </div>
  );
};

export default RewardsAvailable;
